import { IconType } from "react-icons/lib";
import { TbRouteScan } from "react-icons/tb";

import { DriverType } from "./driver.types";

export const EXTERNAL_DRIVER: DriverType = {
    dbId: "external",
    id: "external",
    userId: "external",
    name: "DIŞ TRANSFER",
    vehicle: undefined,
    icon: TbRouteScan,
} as const;
export enum PassengerTypes {
    KLINIK = 1,
    MANUAL = 2,
}
export enum PassengerExtras {
    DEFAULT = 0, // default passenger extras
    HIDE_FOR_WELCOME_TEAM = 2 ** 0, // hide passenger for welcome team
}

export type CommonStatusItem = {
    component: () => IconType;
    hover: string;
    bg: string;
    text: string;
    tooltip: {
        title: string;
        description: string;
    };
};

export enum NotificationCategories {
    UHM_PASSENGER_UPDATE = "transport_svc_uhm_passenger_update",
    OPERATION_SERVICE_UPDATE = "transport_svc_operation_service_update",
    SHIFT_OPERATIONS = "transport_svc_shift_operations",
    HOTEL_CLINIC_REQUEST = "transport_svc_hotel_clinic_request",
    // MEETING_AND_CALL = "transport_svc_meeting_and_call",
    OTHERS = "transport_svc_others",
}

export const NotificationCategoriesAll = Object.values(NotificationCategories).filter(
    (value) => typeof value === "string"
);
export const NotificationCategoriesList = [undefined, ...NotificationCategoriesAll] as const;

export const NotificationCategoriesListWithDetails = [
    NotificationCategories.UHM_PASSENGER_UPDATE,
    NotificationCategories.OPERATION_SERVICE_UPDATE,
] as const;
